<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useStore } from '@/store'
import { ModeEnum, PmsiTypeEnum } from '@/store/modules/settings/types'

const props = defineProps<{
  stayList: number[]
  pmsiType: PmsiTypeEnum
  mode: ModeEnum
}>()

const router = useRouter()
const route = useRoute()
const store = useStore()

const selectedStayIds = computed(() => store.state.stayList.selectedStayIds)
const selectedStaysCount = computed(() => selectedStayIds.value.length)
const isDisabled = computed(() => !props.stayList.length || selectedStaysCount.value === 1)
const label = computed(() => `Parcourir${selectedStaysCount.value > 1 ? ` (${selectedStaysCount.value})` : ''}`)

async function startReadingList() {
  if (isDisabled.value) {
    return 
  }

  if (!selectedStayIds.value.length) {
    props.stayList.forEach((stayId) => {
      if (!store.getters.isStaySelected(stayId)) {
        store.dispatch('toggleSelectedStay', stayId)
      }
    })
  }
  window.sessionStorage.setItem('stayListRoute', route.fullPath)

  await store.dispatch('createReadingList')

  const stayId = store.getters.readingListCurrentStayId
  if (stayId) {
    router.push({
      name: `${props.pmsiType}-stay`,
      params: {
        idType: 'id',
        stayId,
      },
      query: {
        ...route.query,
        readingList: 1,
      }
    })
  }
}
</script>

<template>
  <div
    v-tooltip="{
      content: 'Veuillez sélectionner au moins deux séjours pour créer une liste de lecture',
      disabled: selectedStaysCount !== 1,
      triggers: ['hover', 'focus', 'click'],
    }"
    class="btn sancare-btn btn-fixed-width"
    :class="{ disabled: isDisabled }"
    @click="startReadingList"
  >
    {{ label }}
  </div>
</template>

<style scoped>
.disabled {
  /* Workaround to make warning tooltip visible on hover */
  pointer-events: auto!important;
  cursor: default;
}
</style>
